import React from "react";
import Button from "../../assets/common/button/Button";
import { designImg, profileImg1, profileImg2, profileImg3 } from "..";
import "../feedbackSection/feedBackSection.scss";
import { CgPlayButton } from "react-icons/cg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";

gsap.registerPlugin(ScrollTrigger);
const FeedbackSection = () => {
  const imageRef = useRef(null);

  useEffect(() => {
    const el = imageRef.current;
    if (!el) return;

    // Trigger wave movement on scroll
    ScrollTrigger.create({
      trigger: el,
      start: "top 80%",
      onEnter: () => {
        // Continuous horizontal wave motion
        gsap.to(el, {
          x: 30, // move 30px right and back
          duration: 1.5,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1,
        });
      },
    });
  }, []);

  return (
    <div className="container">
      <div className="row feedback-wrap align-items-center">
        <div className="col-lg-2">
          <Button text="LET'S TALK" />
        </div>
        <div className="col-lg-5 text-center wave-container">
          <img
            // src={designImg}
            alt="design-Img"
            ref={imageRef}
            className="wave-image"
          />
        </div>
        <div className="col-lg-5 feedback-text-wrap">
          <div className="feedback-text">
            <p>
              Brand Craft is a forward-thinking digital marketing agency
              partnering with a diverse range of brands to amplify their online
              presence. Our passionate team of experts specializes in building
              bold digital identities, driving authentic engagement, and
              crafting striking content that resonates. At Brand Craft,
              strategic thinking meets creative excellence delivering results
              that don’t just look good, but create lasting impact in the
              ever-evolving digital space.
            </p>
          </div>
          <div className="row align-items-center profile-video-wrap">
            <div className="col-md-6 profile-img-wrap">
              <img
                // src={profileImg1}
                alt="profile-Img"
                className="profile-Img1"
              />
              <img
                // src={profileImg2}
                alt="profile-Img"
                className="profile-Img2"
              />
              <img
                // src={profileImg3}
                alt="profile-Img"
                className="profile-Img3"
              />
            </div>
            {/* <div className="col-md-6 watch-video-wrap">
              <p>Watch Here </p>
              <span className="play-icon">
                <CgPlayButton />
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSection;
